//jsのみでスムーススクロール
(function(){
  const offset = 70; // ヘッダーの高さ
  const links = document.querySelectorAll('a[href^="#"]');
  links.forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      let href = link.getAttribute('href').substr(1);
      href = href == '#' ? 'html' : `[id="${href}"]`;
      const target = document.querySelector(href);
      const rect = target.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const position = rect.top + scrollTop - offset - 150;
      window.scrollTo({
        top: position,
        behavior: 'smooth'
      });
    });
  });
}());